export interface DocumentHitPost {
    device_type: DeviceType;
    url_referrer: string;
    hyperlink_id: string;
}

export enum DeviceType {
    Unknown = 0,
    Desktop = 1,
    Mobile = 2,
    SearchApp = 3
}
